import { render, staticRenderFns } from "./DocumentsManagerModal.vue?vue&type=template&id=09510bb8&"
import script from "./DocumentsManagerModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports